import { ReactNode, useEffect, useState } from "react";
import {
  Box,
  PopoverProps,
  Popover as MuiPopover,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { Vertical3DotsIcon } from "components";

type PopoverPropsType = Omit<PopoverProps, "open">;
export const Popover = ({
  sx,
  open,
  children,
  paperSx,
  isDisabled = false,
  popoverContent,
  anchorOrigin,
  transformOrigin,
  onClose,
}: {
  sx?: SxProps<Theme>;
  open?: boolean;
  paperSx?: SxProps<Theme>;
  children?: ReactNode;
  isDisabled?: boolean;
  popoverContent?: ReactNode | ((closePopover: () => void) => ReactNode);
  anchorOrigin?: PopoverPropsType["anchorOrigin"];
  transformOrigin?: PopoverPropsType["transformOrigin"];
  onClose?: () => void;
}) => {
  const theme = useTheme();
  const [optionsAnchorEl, setOptionsAnchorEl] = useState<null | HTMLElement>(
    null,
  );

  const handleClickAway = (e: any, option: any) => {
    e.stopPropagation();
    setOptionsAnchorEl(null);
    onClose?.();
  };

  const closePopover = () => {
    setOptionsAnchorEl(null);
    onClose?.();
  };

  useEffect(() => {
    if (open !== undefined) {
      !open && setOptionsAnchorEl(null);
    }
  }, [open]);

  return (
    <>
      <Box
        onClick={(e) => {
          if (!isDisabled) {
            e.stopPropagation();
            setOptionsAnchorEl(e.currentTarget);
          }
        }}
        sx={sx}
      >
        {children}
      </Box>

      <MuiPopover
        open={Boolean(optionsAnchorEl)}
        anchorEl={optionsAnchorEl}
        onClose={handleClickAway}
        anchorOrigin={
          anchorOrigin || {
            vertical: "top",
            horizontal: "right",
          }
        }
        transformOrigin={
          transformOrigin || {
            vertical: "bottom",
            horizontal: "right",
          }
        }
        sx={{ borderRadius: "16px" }}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            overflow: "visible",
            ...paperSx,
          },
        }}
      >
        {typeof popoverContent === "function"
          ? popoverContent(closePopover)
          : popoverContent}
      </MuiPopover>
    </>
  );
};
